import i18n from "../../../i18n";
import { formatTranslation } from "../../../shared/utils/translationUtils";
import { AutozoneColorPalette } from "../types";

export const AutozoneColorPaletteOptions = [
  {
    value: AutozoneColorPalette.DEFAULT,
    label: formatTranslation(i18n.t("autozones.colorPalette.default")),
  },
  {
    value: AutozoneColorPalette.NDVI,
    label: formatTranslation(i18n.t("autozones.colorPalette.ndvi")),
  },
  {
    value: AutozoneColorPalette.ACCESSIBILITY,
    label: formatTranslation(i18n.t("autozones.colorPalette.accessibility")),
  },
];
